import axios from "axios";

export default function updateGlobalSlaConfig({ key, value, hoursType }) {
  const body = {};
  if (value !== undefined) body.value = value;
  if (hoursType !== undefined) body.hours_type = hoursType;
  return new Promise((resolve, reject) =>
    axios
      .put(`/support/api/v1/admin/sla-global-configs/${key}`, body)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
